import Regexp from 'path-to-regexp';

// $flow-disable-line
const regexpCompileCache = Object.create(null);

export default function fillParams(path, params) {
  try {
    const filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = Regexp.compile(path));
    return filler(params || {}, { pretty: true });
  } catch (e) {
    throw new Error(`missing param for ${path}: ${e.message}`);
  }
}
